export const convertNegativeToZero = (value: string | number) => {
  const number = Number(value);
  return number < 0 ? 0 : number;
}
